<template>
  <div class="select" :class="wrapperClasses">
    <BaseLabel
      v-if="label"
      :id="id"
      :number="number"
      :label="label"
      :label-description="labelDescription"
      :required="required"
      :help="help"
      :class="labelClasses"
    />

    <div :class="controlClasses">
      <BaseSelect
        :id="id"
        v-model="data"
        :track-by="trackBy"
        label="name"
        :options="options"
        :searchable="searchable"
        :placeholder="placeholder"
        :multiple="multiple"
        :hide-selected="multiple ? true : false"
        :allow-empty="allowEmpty"
        :group-values="groupValues"
        :group-label="groupLabel"
        :group-select="groupSelect"
        :get-object="getObject"
        :error="error"
        :disabled="disabled"
        :close-on-select="closeOnSelect"
        :max-height="maxHeight"
        :block-tag="blockTag"
        @input="emitEvent"
      />
    </div>
    <div v-if="description || error" :class="descriptionClasses">
      <BaseControlDescription :id="id" :description="description" />
      <BaseControlError :id="id" :error="error" />
    </div>
  </div>
</template>

<script>
import BaseFormControl from "@/components/Base/Form/BaseFormControl";
import BaseSelect from "@/components/Base/Controls/BaseSelect";
import BaseLabel from "@/components/Base/Elements/BaseLabel";

export default {
  name: "SelectControl",
  components: {
    BaseSelect,
    BaseLabel
  },
  extends: BaseFormControl,
  props: {
    value: {
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    trackBy: {
      type: String,
      default: "id"
    },
    getObject: {
      type: Boolean,
      default: true
    },
    searchable: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: "Wybierz..."
    },
    multiple: {
      type: Boolean,
      default: false
    },
    allowEmpty: {
      type: Boolean,
      default: true
    },
    groupValues: {
      type: String,
      default: "",
      required: false
    },
    groupLabel: {
      type: String,
      default: "",
      required: false
    },
    groupSelect: {
      type: Boolean,
      default: false,
      required: false
    },
    closeOnSelect: {
      type: Boolean,
      default: true
    },
    maxHeight: {
      type: Number,
      default: 300
    },
    blockTag: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      data: this.value
    };
  }
};
</script>
